<template>
    <div class="group-item relative">
        <template v-if="Array.isArray(data.condition)">
            <div v-for="(item,index) in data.condition" :key="index" >
                <ConditionGroup
                    v-if="item.logic"
                    :data="item"
                    :verify="verify"
                    @add-condition="addCondition"
                    @toggle-logic="toggleLogic"
                    @change-item="changeConItem"
                    @remove-condition="removeCondition"
                    @check-text="checkText"/>
                <ConditionItem
                    v-else
                    :data="item"
                    :verify="verify"
                    @remove="removeCondition"
                    @change="changeConItem"
                    @check-text="checkText"/>
            </div>

        </template>
        <ConditionItem
            v-else
            :data="data.condition"
            :verify="verify"
            @remove="removeCondition"
            @change="changeConItem"
            @check-text="checkText"></ConditionItem>

        <logicBtn @toggle="toggleLogic" :data="data" v-if="data.logic"/>
        <AddBtn :data="data" @add="(val)=>addCondition(data,val)"/>
    </div>
</template>

<script>
    import ConditionItem from './conditionItem';
    import AddBtn from './addConditionBtn';
    import logicBtn from './conditionLogicBtn';

    export default {
        name: "ConditionGroup",
        props:{
            data:Object,
            verify:Object,
        },
        components:{
            ConditionItem,
            AddBtn,
            logicBtn,
        },
        methods:{
            addCondition(data,type){
                this.$emit('add-condition',data,type);
            },
            toggleLogic(data){
                console.log('toggleLogic11',data);
                this.$emit('toggle-logic',data);
            },
            removeCondition(val){
                this.$emit('remove-condition',val);
            },
            changeConItem(data,type,val,fieldId,conditionType){
                this.$emit('change-item',data,type,val,fieldId,conditionType);
            },
            checkText(data,val){
                this.$emit('check-text',data,val);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .group-item{
        padding: 0 0 10px 60px;
    }
</style>
